import { ForwardedRef, forwardRef } from 'react';

import { DawnTriangleAlert } from '@xemplo/icons';
import { MaybeErrorOrDescription } from '@xemplo/input-utils';
import { useForwardedRef } from '@xemplo/ref-utils';

import * as S from './text-area.styles';
import { TextAreaProps } from './text-area.types';
import { useTextArea } from './use-text-area';

export const TextArea = forwardRef(function TextArea(
  props: TextAreaProps,
  forwardedRef?: ForwardedRef<HTMLTextAreaElement>,
) {
  const textareaRef = useForwardedRef({ forwardedRef });

  const {
    wrapperId,
    wrapperStyle,
    maybeErrorOrDescriptionProps,
    hasError,
    inputId,
    containerClassName,
    labelClassName,
    label,
    leadingIcon,
    trailingIcon,
    textareaProps,
  } = useTextArea(props, textareaRef);

  return (
    <S.Wrapper id={wrapperId} style={wrapperStyle}>
      <S.TextAreaContainer
        onClick={() => textareaRef.current?.focus()}
        className={containerClassName}
      >
        {leadingIcon}
        <S.TextAreaElement {...textareaProps} ref={textareaRef} />
        <S.Label
          htmlFor={inputId}
          className={labelClassName}
          data-testid={`${inputId}-label`}
        >
          {label}
        </S.Label>
        {hasError && !trailingIcon && <DawnTriangleAlert className="error" />}
        {trailingIcon}
      </S.TextAreaContainer>
      <MaybeErrorOrDescription {...maybeErrorOrDescriptionProps} />
    </S.Wrapper>
  );
});

export default TextArea;
